import React, { Component } from "react";
import { View, Text, Image } from "react-native";

class BackgroundImage extends Component {
	render() {
		return (
			<View {...this.props}>
				{this.props.children}
			</View>
		);
	}
}

export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/components/BackgroundImage/index.web.js